import PropTypes from 'prop-types';
import React from 'react';
import StripTags from 'striptags';
import ArticleCard from '../../../components/Community/ArticleCard/ArticleCard';
import CardTitle from '../../../components/Elements/CardTitle/CardTitle';
import SVGFromCloudinary from '../../../components/Elements/SVGFromCloudinary/SVGFromCloudinary';
import CommonCardShell from '../../../components/Layout/CommonCardShell/CommonCardShell';
import SinglePageLayout from '../../../components/Layout/SinglePageLayout/SinglePageLayout';
import {
    SnowplowPageViewTracker,
    PAGE_VIEW_SECTIONS,
    PAGE_VIEW_TYPES,
} from '../../../components/Analytics/Snowplow/SnowplowPageViewTracker';
import { PAGE_PROPS } from '../../defaultProps';

/* STYLESHEETS */
import './ResearchLander.scss';

export default class ResearchLander extends React.PureComponent {
    renderHeaderSection = () => {
        return (
            <div className="header-section">
                <div className="text">
                    <CardTitle headerTag="h1">
                        Research From Fairygodboss
                    </CardTitle>
                    <p>
                        As the largest career community for women, Fairygodboss
                        has unique insights and proprietary data about what
                        women are experiencing in the workplace. Please contact
                        us if you would like to learn more:
                        info@fairygodboss.com
                    </p>
                </div>
                <SVGFromCloudinary cloudinaryID="/SVGs/woman_at_desk.svg" />
            </div>
        );
    };

    renderResearches = () => {
        return (
            <ul className="researches">
                {this.props.researches.map(this.renderResearchCard)}
            </ul>
        );
    };

    renderResearchCard = ({ label, image, title, description, url }, index) => {
        return (
            <li key={`research-card-${index}`}>
                <CommonCardShell className="research-card">
                    <ArticleCard
                        wink={label}
                        contentImage={image}
                        title={title}
                        contentBody={StripTags(description)}
                        url={url}
                        descriptionCharMax={114}
                        showReadMore
                    />
                </CommonCardShell>
            </li>
        );
    };

    render() {
        return (
            <div className="page-CompanyPages-ResearchLander">
                <SnowplowPageViewTracker
                    pageType={PAGE_VIEW_TYPES.COLLECTION}
                    pageSection={PAGE_VIEW_SECTIONS.RESEARCH}
                />
                <SinglePageLayout PAGE_PROPS={this.props.PAGE_PROPS}>
                    {this.renderHeaderSection()}
                    {this.renderResearches()}
                </SinglePageLayout>
            </div>
        );
    }
}

ResearchLander.propTypes = {
    PAGE_PROPS: PAGE_PROPS.isRequired,
    researches: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string.isRequired,
            description: PropTypes.string.isRequired,
            image: PropTypes.shape({
                src: PropTypes.string.isRequired,
                alt: PropTypes.string,
            }).isRequired,
            url: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
};
